import axios from 'axios';
import { Modal } from 'antd';
import qs from 'qs';
import memoize from 'lodash/memoize';

const ERR_CODE_LIST = {
  [400]: '请求参数错误',
  [401]: '无登录权限',
  [403]: '拒绝访问',
  [404]: '请求地址出错',
  [408]: '请求超时',
  [500]: '服务器内部错误',
  [501]: '服务未实现',
  [502]: '网关错误',
  [503]: '服务不可用',
  [504]: '网关超时',
  [505]: 'HTTP版本不受支持',
};

export function getNetworkErrMsg(errResponse) {
  //通过error处理错误码
  const errCode = errResponse.status; //错误码
  const errMsg = ERR_CODE_LIST[errCode]; //错误消息
  console.log(errResponse);

  return {
    errCode,
    errMsg:
      (errResponse && errResponse.data && errResponse.data.message) ||
      (errResponse && errResponse.message) ||
      (errResponse && errResponse.statusText) ||
      // error.message ||
      (errMsg && `${errMsg} [${errCode}]`) ||
      '未知错误',
  };
}

const api = axios.create({
  baseURL: process.env.API_PREFIX,
  responseType: 'json',
});

const getToken = memoize(() =>
  localStorage.getItem(`xb_${process.env.APP_MODE}_token`)
);

api.interceptors.request.use((config) => {
  try {
    const token = getToken();
    config.headers['Authorization'] = 'Bearer ' + token;
  } catch (e) { }

  return config;
});

api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response) {
      const { errCode, errMsg } = getNetworkErrMsg(error.response);

      if (error.response.status && error.response.status === 401) {
        try {
          localStorage.removeItem(`xb_${process.env.APP_MODE}_token`);
        } catch (e) { }

        Modal.confirm({
          title: '无权限',
          closable: false,
          destroyOnClose: true,
          keyboard: false,
          maskClosable: false,
          content: errMsg,
          okText: '知道了',
          onCancel() {
            window.location.reload();
          },
          onOk() {
            window.location.reload();
          },
        });

        return Promise.reject();
      }

      return Promise.reject(new Error(errMsg));

      // return Promise.reject(error.response)
    } else if (error.request) {
      return Promise.reject(error.request);
    } else {
      return Promise.reject(error.message || error.config);
    }
  }
);

export default api;

export const getProfile = () => api.get('/user/profile');
export const uploadFile = (data, config = {}) =>
  api.post(`/files/upload`, data, config);
export const getFileById = (id) => api.get(`/files/${id}`);
export const createTenant = (data) => api.post('/tenants', data);
export const getTenantById = (id) => api.get(`/tenants/${id}`);
export const getWorkers = (params) => api.get('/workers', { params });
export const getWorkersDumpUrl = (params = {}) => {
  const query = new URLSearchParams({
    ...params,
    token: getToken(),
  }).toString();

  return process.env.API_PREFIX + '/workers/dump' + '?' + query;
};
export const getWorkerById = (id) => api.get(`/workers/${id}`);
export const getMembers = (params) => api.get('/users', { params });
export const getMemberById = (id) => api.get(`/users/${id}`);
export const searchUser = (params) => api.get('/users/search', { params });
export const getTenantAssets = (id) => api.get(`/tenants/${id}/assets`);
export const updateTenantAssets = (id, assets) => api.put(`/tenants/${id}/assets`, { assets });
export const getStaffInvitations = (id, params) => api.get(`/tenants/${id}/staff_invitations?limit=100`, { params });
export const sendNotify = (id, params) => api.post(`/notify/send/${id}`, params);
export const readNotify = (id) => api.put(`/notify/read/${id}`);
export const deleteNotify = (id) => api.get(`/notify/delete_history/${id}`);
export const searchSendNotifyHistory = (id, params) => api.get(`/notify/send_history/${id}`, { params });
export const queryTenants = (params) => api.get(`/tenants`, { params });
export const getManagerInvitations = (params) =>
  api.get(`/managers/invitations?limit=100`, { params });
export const getReferralInvitations = (params) =>
  api.get(`/referrals/invitations?limit=100`, { params });
export const createInvitation = (data) => api.post(`/invitations`, data);
export const modifyInvitation = (id, data) => api.put(`/managers/${id}/set_mgroup`, { ...data });

export const createMgroups = (data) => api.post(`/mgroup`, data);
export const getManagers = params => api.get(`/mgroup`, { params })
export const updateManagers = (id, params) => api.put(`/mgroup/${id}`, params)

export const createReferralRule = (data) => api.post(`/referralRule`, data);
export const updateReferralRule = (id, params) => api.put(`/referralRule/${id}`, params)
export const updateReferralBrokerDate = (id, params) => api.put(`/referrals/${id}/updateBroker`, params)

export const updateRetailReferralBrokerDate = (id, params) => api.put(`/referrals/${id}/retailUpdateBroker`, params)
export const createSkills = (data) => api.post(`/productCategory`, data);
export const getProductCategory = params => api.get(`/productCategory`, { params })
export const findRecommend = params => api.get(`/productCategory/findRecommend`, { params })
export const updateSkills = (id, params) => api.put(`/productCategory/${id}`, params)

export const getStaffs = (id, params) => api.get(`/staffs/${id}`, params)
export const getStaffsByUserId = (id, params) => api.get(`/staffs/getByUserId/${id}`, params)
export const saveStaffs = (id, params) => api.put(`/staffs/${id}/save_order_necessary`, params)

export const updateWorker = (id, data) => api.put(`/workers/${id}`, data);
export const payForWorker = (id) => api.put(`/workers/${id}/pay_for_worker`);
export const createProduct = (data, params) =>
  api.post('/products', data, { params });
export const updateProduct = (id, data, params) =>
  api.put(`/products/${id}`, data, { params });
export const searchProduct = (keyword) =>
  api.get('/products', { params: { keyword } });
export const searchTenant = (keyword) =>
    api.get('/tenants', { params: { keyword } });
export const searchOrder = (keyword) =>
  api.get('/orders', { params: { keyword } });
export const searchReferral = (keyword) =>
  api.get('/referrals', { params: { keyword } });
export const searchRetail = (keyword) =>
  api.get('/referrals/retail', { params: { keyword } });
export const reservice = (id, params) =>
  api.post(`/orders/${id}/reservice`, { params });
export const checkSameOrders = (params) =>
  api.post(`/orders/check_same_orders`, params);

export const getOrderById = (id) => api.get(`/orders/${id}`);
export const findManager = (params) => api.get(`/managers`, { params });
export const searchWorker = (params) => api.get(`/workers`, { params });
export const getFinancesSummary = (params) => api.get('/finances/summary');
export const getTransactions = (params) =>
  api.get('/finances/transactions', { params });
export const getFundFlows = (params) =>
  api.get('/finances/fund_flows', { params });
export const downloadWorkerPayroll = () =>
  process.env.API_PREFIX + '/finances/payroll?tkn=' + getToken();
export const getUnbilledList = (params) =>
  api.get('/bills/unbilled_transations', { params });
export const genBill = (data, params) =>
  api.post('/bills/gen', data, { params });
export const getBills = (params) => api.get('/bills', { params });
export const billDump = (id) => api.get(`/bills/${id}/dump`, { responseType: "blob" });
export const unbillDump = (tenant) => api.get(`/nobills/${tenant}/dump`, { responseType: "blob" });
export const billConfirm = (id) => api.post(`/bills/${id}/confirm`);
export const billSettlement = (id) => api.post(`/bills/${id}/settlement`);
export const fetchTenantCoupons = (status) => api.get(`/coupon/tenant/${status}`);
export const fetchWorkerCoupons = (status) => api.get(`/coupon/worker${status}`);
export const updateBonusCouponStatus = (id, status) => api.put(`/bonusCoupon/${id}/${status}`);
export const updateCashCouponStatus = (id, status) => api.put(`/cashCoupon/${id}/${status}`);
export const joinRequestList = (params) =>
  api.get('/workers/join_request', { params });
export const getReferralBindedEnterprises = (refId) =>
  api.get(`/referrals/${refId}/bindings`);

export const getRetailBindedList = (refId) =>
  api.get(`/referrals/${refId}/retailBindings`);
export const bindReferral = (refId, data) =>
  api.post(`/referrals/${refId}/bind`, data);
export const unbindReferral = (refId, data) =>
  api.post(`/referrals/${refId}/unbind`, data);
export const changeRetailReferral = (oldRef,newRef,data) =>
  api.post(`/referrals/changeRetail/${oldRef}/${newRef}`, data)
export const changeReferral = (oldRef,newRef,data) =>
  api.post(`/referrals/change/${oldRef}/${newRef}`, data)

export const bindRetailReferral = (retId, data) =>
  api.post(`/referrals/${retId}/retailBind`, data);

export const unbindRetailReferral = (refId, data) =>
  api.post(`/referrals/${refId}/retailUnbind`, data);
export const handleJoinRequest = (data) =>
  api.post(`/manager/worker_join_request/handle`, data);
export const getReferralUnbilledList = (refId) =>
  api.get(`/referrals/${refId}/unbilled`);

export const getRetailReferralUnbilledList = (refId) =>
  api.get(`/referrals/${refId}/retailUnbilled`);

export const referralConfirmSettlement = (refId, data) =>
  api.post(`/referrals/${refId}/confirm_settlement`, data);

export const retailReferralConfirmSettlement = (refId, data) =>
  api.post(`/referrals/${refId}/confirm_retail_settlement`, data);
export const referralSettlement = (refId, data) =>
  api.post(`/referrals/${refId}/settlement`, data);
export const smartParseAddrText = (address) =>
  api.post(`/tools/adress_nlp`, { address });
export const setWorkingState = (id, data) =>
  api.put(`/managers/${id}/set_working`, data);
export const searchByIndex = (index, params) =>
  api.get(`/search/${index}`, { params });
export const getManagerDashboardData = (params) =>
  api.get('/managers/dashboard');
export const callNumber = (data) => api.post('/call', data);
export const getOrderStatistic = (params) => api.get('/orders/statistic', { params });
export const recharge = (data) => api.post('/tenants/recharge', data);
export const setPermissions = (id, data) =>
  api.put(`/staffs/${id}/permissions`, data);
export const downloadTransactionsUrl = (params = {}) => {
  const query = new URLSearchParams({
    ...params,
    token: getToken(),
  }).toString();

  return (
    process.env.API_PREFIX + '/finances/download_transactions' + '?' + query
  );
};
export const getOrdersDumpUrl = (params = {}) => {
  const query = new URLSearchParams({
    ...params,
    token: getToken(),
  }).toString();

  return process.env.API_PREFIX + '/orders/dump' + '?' + query;
};

export const getProductDumpUrl = (params = {}) => {
  const query = new URLSearchParams({
    ...params,
    token: getToken(),
  }).toString();

  return process.env.API_PREFIX + '/products/dump/csv' + '?' + query;
};

export const getTenantCouponCount = (params) => api.get('/coupon/stats/tenantCouponCount', { params });
export const getTenantCouponAmount = (params) => api.get('/coupon/stats/tenantCouponAmount', { params });
export const getWorkerCouponAmount = (params) => api.get('/coupon/stats/workerCouponAmount', { params });
export const getWorkerCouponCount = (params) => api.get('/coupon/stats/workerCouponCount', { params });
export const getTenantCouponDailyCount = (params) => api.get('/coupon/stats/tenantCouponDailyCount', { params });
export const getTenantCouponDailyAmount = (params) => api.get('/coupon/stats/tenantCouponDailyAmount', { params });
export const getWorkerCouponDailyCount = (params) => api.get('/coupon/stats/workerCouponDailyCount', { params });
export const getWorkerCouponDailyAmount = (params) => api.get('/coupon/stats/workerCouponDailyAmount', { params });
export const queryExpressCompany = (params) => api.get('/express/codes', { params });


export const authLogin = (data, params) => api.post('/auth/login', data, { params });
export const forgetPass = (data, params) => api.post('/auth/forgetPass', data, { params });
export const addManager = (data, params) => api.post('/addManager', data, { params });
export const editManager = (data, params) => api.post('/editManager', data, { params });
export const addStaff = (data, params) => api.post('/addStaff', data, { params });
export const editStaff = (data, params) => api.post('/editStaff', data, { params });
export const queryDashboardCustom = (params) => api.get('/dashboard/custom', { params });
export const queryDashboardCompany = (params) => api.get('/dashboard/company', { params });
export const queryDashboardWorker = (params) => api.get('/dashboard/worker', { params });
export const queryReferralInvite = (params) => api.get(`/referral/referralInvite`, { params });
export const downloadManagerDump = (params) => api.get(`/orders/manager/dump`, { responseType: "blob", params });
export const downloadTenantDump = (params) => api.get(`/orders/tenant/dump`, { responseType: "blob", params });
export const workerServiceFee = (data, params) => api.post(`/workers/serviceFee`, data, { params });
export const offWork = (data, params) => api.post(`/manager/offWork`, data, { params });
export const findAllProductTotal = (params) => api.get('/findAllProductTotal', { params });
export const queryOrdersRecentUse = (params) => api.get('/orders/recent/use', { params });
export const mystaffUpdate = (data, params) => api.post(`/tenants/mystaff/update`, data, { params });
export const getAllReasons = async (params) => {
  const { type } = params
  const key = `allReasons${type}`
  let storage = localStorage.getItem(key)
  try {
    storage = JSON.parse(storage)
  } catch (error) { }

  if (storage && typeof storage === 'object' && storage.reason) {
    return storage
  } else {
    const datas = await api.get('/allReasons', { params })
    localStorage.setItem(key, JSON.stringify(datas))
    return datas
  }
};
export const exchangeAccount = (params) => api.get(`/tenant/staff/exchangeAccount`, { params });